// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCheckboxGroup_root__YaQnr","list":"FieldCheckboxGroup_list__3jPXG","twoColumns":"FieldCheckboxGroup_twoColumns__OYg92","item":"FieldCheckboxGroup_item__1yzMp"};